import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class PaginationComponent extends Vue {
  @Prop({ required: true })
  public totalPages!: number;

  @Prop({ required: true })
  public selectedPage!: number;

  public page = 1;

  @Watch('selectedPage')
  public pageChanged() {
    this.page = this.selectedPage;
  }

  @Watch('page')
  public goToPage() {
    this.$emit('update:selectedPage', this.page);
  }
}
